<app-iota-modal title="Upload documents" i18n-title [modalOptions]="modalOptions" (close$)="closeDialog()">
    <div modal-body class="p-5 flex flex-col gap-3">
        <div class="flex flex-col gap-3" *ngIf="isInUploadStep$ | ngrxPush">
            <span class="font-bold text-xl" i18n>Upload and provide documents to customer</span>
            <span i18n>With this tool you can upload one or more documents, categorize and provide it to the customer</span>
        </div>
        <app-smart-dialog-steps [stepLabels]="stepLabels" [currentStep]="currentStep$ | ngrxPush"></app-smart-dialog-steps>

        <app-smart-document-upload-file-upload
            (setNextButtonDisabled)="setNextButtonDisabled($event)"
            *ngIf="isInUploadStep$ | ngrxPush"
            [isHwp]="data?.isHwp"
            [mode]="data?.mode"
            #fileUploadComponent
        ></app-smart-document-upload-file-upload>

        <app-smart-dialog-result
            [loading]="loading$ | ngrxPush"
            [error]="apiError$ | ngrxPush"
            [numberOfSuccessfulUploads]="numberOfUploadedFiles$ | ngrxPush"
            i18n-successfulUploadsSuffix
            successfulUploadsSuffix="documents have been uploaded."
            *ngIf="isInResultStep$ | ngrxPush"
        ></app-smart-dialog-result>
    </div>

    <ng-container modal-footer *ngIf="!(isInResultStep$ | ngrxPush)">
        <div class="w-full flex flex-row items-center gap-4">
            <button class="btn btn-sm btn-ghost rounded-full" *ngIf="isInUploadStep$ | ngrxPush" (click)="closeDialog()" i18n>
                Cancel
            </button>
            <div class="flex-1"></div>
            <button
                class="btn btn-sm btn-outline rounded-full flex flex-row items-center gap-2"
                [disabled]="nextButtonDisabled"
                (click)="nextStep()"
            >
                <span i18n>Upload next file</span>
            </button>
            <button
                class="btn btn-sm btn-primary rounded-full flex flex-row items-center gap-2"
                [disabled]="nextButtonDisabled"
                (click)="submit()"
            >
                <span i18n>Submit</span>
                <div><iota-icon icon="arrow-long-right"></iota-icon></div>
            </button>
        </div>
    </ng-container>

    <ng-container modal-footer *ngIf="isInResultStep$ | ngrxPush">
        <button class="btn btn-sm btn-primary rounded-full flex flex-row items-center gap-2" (click)="closeDialog()">
            <span i18n>Close</span>
        </button>
    </ng-container>
</app-iota-modal>
